module.exports = __webpack_public_path__ + "static/state-daw-7e39dacd4e75ba46d84bd694bb1d5bd3.png";